export default __webpack_public_path__ + "static/media/ayushi.36e274e7.jpeg";